import { useCallback, useEffect, useState } from "react";
import styles from "../../../pages/ordermanager/Orders.module.css";
import { CloseIcon } from "../../icons/Icon2";
import Button from "../Dealers/Button";
import CheckBox from "../FormComponents/CheckBox";
import { useToast } from "../Toaster/Toaster";

const ConfirmVerification = ({
  mode,
  handleCloseModal,
  onVerified,
  modalName,
  setModalName,
}) => {
  const { show } = useToast();

  const [isChecked, setIsChecked] = useState(false);
  const [generatedLetter, setGeneratedLetter] = useState("");
  const [loading, setLoading] = useState(false);

  const generateLetter = () => {
    let letter;
    do {
      const code = Math.floor(Math.random() * 26) + 65;
      letter = String.fromCharCode(code);
    } while (letter === "V");
    return letter;
  };

  const getAllowedLetters = useCallback(() => {
    const letters = [];
    for (let i = 65; i <= 90; i++) {
      const letter = String.fromCharCode(i);
      if (letter !== "V") {
        letters.push(letter.toLowerCase());
      }
    }
    return letters;
  }, []);

  useEffect(() => {
    setGeneratedLetter(generateLetter());
  }, []);

  const resetAfterSuccess = useCallback(() => {
    setIsChecked(false);
    setGeneratedLetter(generateLetter());
  }, []);

  const handleSubmit = useCallback(async () => {
    if (loading) return;

    try {
      setLoading(true);
      await Promise.resolve();
      onVerified();
      resetAfterSuccess();
      handleCloseModal();
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, [handleCloseModal, loading, onVerified, resetAfterSuccess]);

  useEffect(() => {
    const allowedLetters = getAllowedLetters();

    const handleKeyUp = async (e) => {
      if (modalName === "ConfirmVerification") {
        const key = e.key;
        e.stopPropagation();
        if (key === generatedLetter.toLowerCase()) {
          await handleSubmit();
        } else if (key === "Escape") {
          handleCloseModal();
          setModalName("AddReceiptModal");
        } else {
          if (allowedLetters.includes(key)) {
            show("Press the shown key only!", "warning");
          }
        }
      }
    };
    window.addEventListener("keyup", handleKeyUp);
    return () => {
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, [
    generatedLetter,
    getAllowedLetters,
    handleCloseModal,
    handleSubmit,
    modalName,
    setModalName,
    show,
  ]);

  return (
    <div
      className={`${styles.confirm_verification} ${
        mode ? styles.confirm_verification_dark : ""
      }`}
    >
      <div className={styles.confirm_verification_header}>
        <p>Confirm Receipt Verification</p>
        <div>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              handleCloseModal();
              setModalName("AddReceiptModal");
            }}
          >
            <CloseIcon mode={mode} />
          </div>
        </div>
      </div>

      <div>
        <p style={{ margin: 0 }}>To confirm press the same character.</p>
      </div>

      <div>
        <p className={styles.confirm_verification_letter}>{generatedLetter}</p>
      </div>

      <div>
        <p className={styles.or_text}>OR</p>
      </div>

      <div className={styles.confirm_verification_checkbox}>
        <CheckBox
          checked={isChecked}
          handleChange={() => setIsChecked((prev) => !prev)}
        />
        <p>Check this then proceed</p>
      </div>

      <div className={styles.bottom_buttons}>
        <Button
          buttonText={"Cancel"}
          buttonBgColor={"#000000"}
          buttonTextColor={"#ffffff"}
          buttonBorder={"none"}
          buttonClick={() => {
            handleCloseModal();
            setModalName("AddReceiptModal");
          }}
        />

        <Button
          buttonText={"Proceed"}
          buttonBgColor={"#4164E3"}
          buttonTextColor={"#ffffff"}
          buttonBorder={"none"}
          buttonClick={handleSubmit}
          disabled={!isChecked || loading}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default ConfirmVerification;
